<div class="container section-gap">
  <div class="pictograph-container">
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-12">
        <kla-title [lineConfig]="lineConfig" [config]="config.title" [showFooter]="false"></kla-title>
      </div>
    </div>
    <div class="pictograph-content"
         #pictographContent
         tabindex="0"
         role="group"
         [attr.aria-label]="(config.chartAltText || ((config.title?.header ? config.title.header + ', ' : '') + config.title?.title + ' chart' + (config.title?.description ? ', ' + config.title?.description : ''))) + ', Press Enter to interact with chart'"
         (keydown)="onContainerKeydown($event)">
      <div class="row">
        <div class="col-lg-4 col-sm-6 col-6 offset-lg-0 pictograph-data-col"
             #col1
             [ngClass]="{'offset-3': !showSecondPictograph }"
             tabindex="0"
             role="img"
             [attr.aria-label]="activePictograph?.year + ' ' + activePictograph?.firstGraph?.description + ', ' + activePictograph?.firstGraph?.subject + ' = ' + activePictograph?.firstGraph?.percentage + '%'"
             (keydown)="onDataColKeydown($event, 0)">
          <h4 aria-hidden="true"> {{activePictograph?.year}} {{activePictograph?.firstGraph?.description}} </h4>
          <div class="pictograph-icons" aria-hidden="true">
            <i [class]="'icon-' + activePictograph?.firstGraph?.icon + ' icon'"
               *ngFor="let number of maxNumber; index as i"
               [ngStyle]="{'color': activePictograph?.firstGraph?.iconColor}"
               [ngClass]="{'blured': activePictograph.firstGraph.percentage < i + 1 }"
               aria-hidden="true"></i>
          </div>
          <div class="pictograph-legend" aria-hidden="true">
            <i [class]="'icon-' + activePictograph?.firstGraph?.icon"
               [ngStyle]="{'color': activePictograph?.firstGraph?.iconColor}"
               aria-hidden="true"></i>
            <p>{{activePictograph?.firstGraph?.subject}} = {{activePictograph?.firstGraph?.percentage}}%</p>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6 col-6 pictograph-data-col"
             #col2
             *ngIf="showSecondPictograph"
             tabindex="0"
             role="img"
             [attr.aria-label]="activePictograph?.year + ' ' + activePictograph?.secondGraph?.description + ', ' + activePictograph?.secondGraph?.subject + ' = ' + activePictograph?.secondGraph?.percentage + '%'"
             (keydown)="onDataColKeydown($event, 1)">
          <h4 aria-hidden="true">{{activePictograph?.year}} {{activePictograph?.secondGraph?.description}}</h4>
          <div class="pictograph-icons" aria-hidden="true">
            <i [class]="'icon-' + activePictograph?.secondGraph?.icon + ' icon'"
               *ngFor="let number of maxNumber; index as i"
               [ngStyle]="{'color': activePictograph?.secondGraph?.iconColor}"
               [ngClass]="{'blured': activePictograph.secondGraph.percentage < i + 1 }"
               aria-hidden="true"></i>
          </div>
          <div class="pictograph-legend" aria-hidden="true">
            <i [class]="'icon-' + activePictograph?.secondGraph?.icon"
               [ngStyle]="{'color': activePictograph?.secondGraph?.iconColor}"
               aria-hidden="true"></i>
            <p>{{activePictograph?.secondGraph?.subject}} = {{activePictograph.secondGraph.percentage}}%</p>
          </div>
        </div>

        <div class="col-lg-4 col-sm-12" role="group" aria-label="Select year">
          <div class="slection-button" *ngFor="let item of pictographConfig?.data; index as i">
            <kla-round-button [title]="item?.year" [activeButton]="selectedButton == i"
                              (click)="changeActivePictograph(i)"
                              (keydown)="onYearKeydown($event, i)"></kla-round-button>
          </div>
        </div>

        <div class="footer-paragraph col-lg-8 col-12" *ngIf="config.title.footer">
          <app-dynamic-content
              [contentId]="'pictograph-footer'"
              [htmlContent]="config.title.footer">
            </app-dynamic-content>
        </div>

      </div>
    </div>
  </div>
</div>
